export enum CorePermission {
  login = "login",
  order = "order",
  academy = "academy",
  licenses = "licenses",
  returns = "returns",
  brandstore = "brandstore",
  partnerProgram = "partnerProgram",
  partnerProgramConsumer = "partnerProgramConsumer",
  partnerProgramRestrictedData = "partnerProgramRestrictedData",
  partnerProgramCreateOpportunity = "partnerProgramCreateOpportunity",
  viewUserManagement = "viewUserManagement",
  partnerInfoManagement = "partnerInfoManagement",
  userManagement = "userManagement",
  distributorUserManagement = "distributorUserManagement",
}
